export default __webpack_public_path__ + "static/media/CL06.1.b761624f.mp3";